export const TTV_CONVERSION_SOUND_IDS_STORAGE_KEY =
  "audimee:ttv-conversion-sounds:v1";
